import { render, staticRenderFns } from "./lazyblock_map_by_categories.vue?vue&type=template&id=40a0336a&scoped=true"
import script from "./lazyblock_map_by_categories.vue?vue&type=script&lang=js"
export * from "./lazyblock_map_by_categories.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_map_by_categories.vue?vue&type=style&index=0&id=40a0336a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a0336a",
  null
  
)

export default component.exports